import { authenticatedProApiFetch } from './pro-api.client';

export interface SimulationActiveSession {
  productId: string;
  name: string;
  simulationExpAt: string | null;
  sessionStartedAt: string | null;
}

export interface SimulationPausedSession {
  productId: string;
  name: string;
  historyRowCount: number;
}

export interface SimulationStats {
  totalSimulated: number;
  activelySimulating: number;
  historyRowCount: number;
  retentionMs: number;
  activeSessions: SimulationActiveSession[];
  pausedSessions: SimulationPausedSession[];
}

export async function fetchSimulationStats(accessToken: string): Promise<SimulationStats> {
  return authenticatedProApiFetch<SimulationStats>('/simulation/stats', accessToken);
}

export async function clearProductSimulationHistory(accessToken: string, productId: string): Promise<void> {
  await authenticatedProApiFetch(`/products/${productId}/simulation/history`, accessToken, { method: 'DELETE' });
}
